import './Footer.css';

const Footer = () => {
    return ( 
        <>
            <div className="footer">
                <div className="profile">
                    <div className="footerGap">
                        <h3>Profile</h3>
                        <a href="###">FAQ</a>
                        <a href="###">Pricing Plans</a>
                        <a href="###">Order Tracking</a>
                        <a href="###">Returns</a>
                    </div>
                </div>
                <div className="profile">
                    <div className="footerGap">
                        <h3>Recent posts</h3>
                        <a href="###">Touch Of Uniqueness</a>
                        <a href="###">Offices You Won't Forget</a>
                        <a href="###">Cicilan</a>
                    </div>
                </div>
                <div className="profile">
                    <div className="footerGap">
                        <h3>Customer</h3>
                        <a href="###">Help & Contact Us</a>
                        <a href="###">Return</a>
                        <a href="###">Online Stores</a>
                        <a href="###">Terms & conditions</a>
                    </div>
                </div>
                <div className="contact">
                    <h3>Contact</h3>
                    <div className="contactIcon">
                        <i className="fab fa-instagram"></i>
                        <i className="fab fa-twitter"></i>
                        <i className="fab fa-facebook-square"></i>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Footer;
